import { DobButton, DobIcon } from '@dedalusdiit/dob-components';
import Styles from './JustificationCell.module.scss';

enum JustificationStatus {
    None = 0,
    NeedJustification = 1,
    PartialJustification = 2,
    HasJustification = 3,
    FilledNoRequired = 4,
}

interface JustificationCellProps {
    justificationStatus: JustificationStatus;
    onClick?: () => void;
}

interface IconState {
    color: string;
    isPartial: boolean;
}

function getIconState(status: JustificationStatus): IconState {
    switch (status) {
        case JustificationStatus.None:
            return { color: 'var(--color-primary-contrast-hover-300)', isPartial: false };
        case JustificationStatus.NeedJustification:
            return { color: 'var(--color-primary-required)', isPartial: false };
        case JustificationStatus.PartialJustification:
            return { color: 'var(--color-primary-required)', isPartial: true };
        case JustificationStatus.HasJustification:
            return { color: 'var(--color-success)', isPartial: false };
        case JustificationStatus.FilledNoRequired:
            return { color: 'var(--color-primary-contrast-hover-300)', isPartial: true };
        default:
            return { color: 'var(--color-primary-contrast-hover-300)', isPartial: false };
    }
}

export function JustificationCell({
    justificationStatus,
    onClick,
}: Readonly<JustificationCellProps>) {
    const { color, isPartial } = getIconState(justificationStatus);

    return (
        <DobButton
            type="button"
            color="silent"
            size="small"
            className={`${Styles.justificationCell} ${isPartial ? 'partial' : ''}`}
            onClick={(e) => {
                e.stopPropagation();
                onClick?.();
            }}
        >
            <DobIcon name="check-circle-fill" size="20px" style={{ color }} />
        </DobButton>
    );
}
